/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { get, set, action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
// External Imports
import DataType from '@linc-technologies/linced-common/enums/data-type';
// Internal Imports
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';
import {
  findBy,
  resolved,
} from '@linc-technologies/linced-common/utils/arrays';

export default class BatchList extends Component {
  @tracked
  dialogOpen = false;
  @tracked
  filters = [];
  medication = null;

  @computed(
    'medication.batches.content.@each.deleted',
    'filters.@each.{field,value}',
  )
  get filteredBatches() {
    // resolve the async hasMany relationship upfront.
    let batches = resolved(this.medication.batches).filter(
      (batch) => !batch.deleted,
    );

    // Determine datatypes for any specified filters.
    let filters = this.filters.map((filter) => {
      return {
        key: filter.field,
        dataType: DataType.STRING,
        value: filter.value,
      };
    });

    // Apply all filters to each row in one hit, to avoid iterating over a
    // (potentially) large dataset multiple times.
    return batches.filter((row) => {
      return filters.every((filter) => {
        // Generic filter processing.
        return filterValue(
          get(row, filter.key) ?? '',
          filter.dataType,
          filter.value,
        );
      });
    });
  }

  @action
  filter(field, value) {
    let filter = findBy(this.filters, 'field', field);
    if (isEmpty(filter)) {
      // No existing filter on this field; add it.
      this.filters = [...this.filters, { field, value }];
      return;
    }

    if (isEmpty(value)) {
      // Filter has been cleared; remove it.
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      // Existing filter has been changed; update it.
      set(filter, 'value', value);
    }
  }

  @action
  openDialog() {
    this.dialogOpen = true;
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
  }
}
